module.exports = __webpack_public_path__ + "static/media/house-yellow.54b06750.svg";